import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/authService';
import './FaqPublicChrome.css';

export function FaqPublicChrome({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const authed = authService.isAuthenticated();

  useEffect(() => {
    document.documentElement.classList.add('public-route');
    return () => document.documentElement.classList.remove('public-route');
  }, []);

  return (
    <div className="saas-faq-public">
      <header className="saas-faq-public__bar">
        <div className="saas-faq-public__brand">
          <span className="saas-faq-public__logo">{t('page.title')}</span>
          <span className="saas-faq-public__tag">{t('faq.pageBadge')}</span>
        </div>
        <div className="saas-faq-public__actions">
          {authed ? (
            <Link to="/" className="saas-faq-public__btn saas-faq-public__btn--primary">
              {t('faq.backToApp')}
            </Link>
          ) : (
            <Link to="/login" className="saas-faq-public__btn saas-faq-public__btn--primary">
              {t('faq.loginCta')}
            </Link>
          )}
        </div>
      </header>
      <main className="saas-faq-public__main">{children}</main>
    </div>
  );
}
